// This is all you.
import Alpine from "alpinejs";
import intersect from "@alpinejs/intersect";
import CcFileUpload from "./cc-file-upload";
import CcWishList from "./cc-wishlist";
//https://getbootstrap.com/docs/5.0/getting-started/javascript/
import Modal from "bootstrap/js/dist/modal";
import Editor from "@toast-ui/editor";
import ccFileUploadLightboxSetup from './cc-file-upload-lightbox-setup.js';
import FormLeaveHandler from "./form-leave-handler.js";





Alpine.plugin(intersect);

window.Alpine = Alpine;

window.ccFileUploadLightboxSetup = ccFileUploadLightboxSetup;
window.FormLeaveHandler = FormLeaveHandler;
window.CcWishList = CcWishList;
window.Editor = Editor;
// window.CcConfirmationDialog = CcConfirmationDialog;
//https://getbootstrap.com/docs/5.0/getting-started/javascript/
if (!window.bootstrap) window.bootstrap = {};
window.bootstrap.Modal = Modal;

// import PhotoSwipeLightbox from "photoswipe/lightbox";

// const lightbox = new PhotoSwipeLightbox({
//     gallery: "#lightbox",
//     children: "a",
//     pswpModule: () => import("photoswipe"),
// });
// lightbox.init();

// Global State for Menu
Alpine.store("menuOpen", {
    on: false,
    scrollDistance: 0,
    menuIsOpen: false,

    toggle() {
        this.on = !this.on;
    },

    open() {
        if(window.innerWidth<992){ 
            this.scrollDistance = document.documentElement.scrollTop;
            this.menuIsOpen = true;
        }
        this.on = true;        
    },

    close() {

        this.on = false;
        if(this.menuIsOpen && window.innerWidth<992){
            setTimeout(function() {
                
                document.documentElement.scrollTo({
                    top: Alpine.store('menuOpen').scrollDistance,
                    left: 0,
                    behavior: 'instant'
                });
                Alpine.store('menuOpen').menuIsOpen = false;
            }, 50);
        }           
    },
});

//libs references the external scripts loaded on page
Alpine.store("extScript", {
    libs: [],
    loadScript(lib) {
        if (this.libs[lib]) {
            return this.libs[lib];
        } else {
            var script = document.createElement("script");
            this.libs[lib] = script;
            script.setAttribute("src", lib);

            if (lib.includes("googleapis")) {
                script.setAttribute("data-cookieconsent", "ignore");
            }
            
            document.getElementsByTagName("head")[0].appendChild(script);
            console.log(lib);
            return script;
        }
    },
});

Alpine.store("elements", {
    searchBarEl: false,
    articleFiltersEl: false,
    // Add DOM elements here to access from different components
});

Alpine.store("pageTitle", {
    save(title) {
        sessionStorage.setItem("xb-prev", title);
    },
    get() {
        //check history for title
        if(history.state){
            return history.state.prev;
        } else {
            //use session & save to history
            let ss_prev = sessionStorage.getItem("xb-prev");
            if (ss_prev == null) ss_prev="previous";
            let state = { 'prev': ss_prev };
            history.replaceState(state , document.title, window.location.pathname);
            return ss_prev; 
        }      
    },
    back() {
        sessionStorage.removeItem("xb-prev");
    }
});

Alpine.start();

//nav filter reset
const navFilter = document.querySelector("#nav-filter");
const navFilterClear = document.querySelector("#filter-clear");

function clearFilter(e) {
    if (navFilter) {
        navFilter.reset();
        navFilter.querySelectorAll('input[type="checkbox"]:checked').forEach(el => el.checked = false);
        navFilter.querySelectorAll('select').forEach(el => el.selectedIndex = 0);
        navFilter.querySelectorAll('#prop-filter').forEach(el => el.remove());
    }
}

if (navFilterClear) {
    navFilterClear.addEventListener("click", clearFilter);
}


(new CcFileUpload()).init();